import { render, staticRenderFns } from "./ForgotPasswordComponent.vue?vue&type=template&id=61287a92&scoped=true"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordComponent.vue?vue&type=style&index=0&id=61287a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61287a92",
  null
  
)

export default component.exports